"use client";
import { motion } from "motion/react";
import { ExtractBySectionType, SectionType } from "types";
import { SanityImage } from "../sanity-image";
import { SanityImageSource } from "@sanity/image-url/lib/types/types";

type TrustSignals = ExtractBySectionType<SectionType, "trustSignals", "_type">;

export function Partners({ data }: { data: TrustSignals }) {
  const { heading, signals } = data;
  const assets = signals
    ? signals.reduce((acc, curr) => {
        const image = curr.type == "logo" ? curr.logo : curr.badge;
        if (image) {
          acc.push(image);
        }
        return acc;
      }, [] as SanityImageSource[])
    : [];

  const length = assets.length;
  if (length < 10) {
    const needed = 10 - length;
    for (let i = 0; i < needed; i++) {
      assets.push(assets[i % length]);
    }
  }

  //TODO: get height and width from image metadata
  const height = 30;
  const width = 170;
  const quantity = assets.length;

  // Animation timing - increase duration for slower animation
  const animationDuration = 30; // Increased from 15 to 25 seconds
  const itemDelay = animationDuration / quantity; // This ensures smooth spacing

  return (
    <section className="bg-white w-full mx-auto max-w-screen-2xl py-8 h-full flex flex-col items-center justify-center overflow-hidden [mask-image:linear-gradient(to_right,transparent,#000000_10%,#000000_90%,transparent)] gap-8">
      <h4 className="text-sm lg:text-lg font-medium">{heading}</h4>
      <div
        className="flex w-full relative"
        style={{ minWidth: `${quantity * width}px`, height: `${height}px` }}
      >
        {assets.map((item, index) => (
          <motion.div
            style={{
              height: `${height}px`,
              width: `${width}px`,
              position: "absolute",
              left: "100%",
            }}
            animate={{
              left: ["100%", `-${width}px`],
            }}
            transition={{
              duration: animationDuration,
              ease: "linear",
              repeat: Infinity,
              delay: -itemDelay * index,
            }}
            key={index}
          >
            <SanityImage
              src={item}
              alt={`logo ${index}`}
              height={height}
              width={width}
              className="h-full w-full object-contain"
            />
          </motion.div>
        ))}
      </div>
    </section>
  );
}
